export default __webpack_public_path__ + "static/media/shield-icon.ad2aab9b.svg";